import React from "react";
import ImageComponent from "../../ImageComponent";

export default function AutoTrackIcon({ onPress, isAutoTracked, style }) {
  return (
    <>
      {isAutoTracked ? (
        <ImageComponent
          action={onPress}
          image={require("../../../../../assets/fab-icons/Close.png")}
          style={style}
        />
      ) : (
        <ImageComponent
          action={onPress}
          image={require("../../../../../assets/fab-icons/wand.png")}
          style={style}
        />
      )}
    </>
  );
}
